import { useTranslate } from 'module/hooks/use-translation';
import { Option } from 'module/ui/components/atoms/select/types';
import { UiFieldType } from '../fields/types';

export const fieldTypeAsOptions = (
  translate: ReturnType<typeof useTranslate>,
): Option[] =>
  Object.values(UiFieldType).map((type) => ({
    value: type,
    label: translate(`fields.label.${type.toLowerCase()}` as any),
  }));
